import { Box, Card } from '@palmetto/palmetto-components';
import React from 'react';

import { OrganizationNode } from '../../../../types/Organizations';

import PaymentCardHeader from './PaymentCardHeader';

interface PaymentCardProps {
  href?: string;
  isPhone?: boolean;
  organization?: OrganizationNode | undefined;
  onClick?: () => void;
  cardTitle: string;
  isLoading?: boolean;
  children?: React.ReactNode;
  isInherited?: boolean;
  orgHasSignatoryEmails?: boolean;
}

const PaymentCard = ({
  href,
  cardTitle,
  isPhone,
  organization,
  isLoading,
  children,
  isInherited,
  orgHasSignatoryEmails,
  onClick,
}: PaymentCardProps) => {
  return (
    <Card height="400px">
      <PaymentCardHeader
        organization={organization}
        isPhone={isPhone}
        cardTitle={cardTitle}
        href={href}
        onClick={onClick}
        isInherited={isInherited}
        orgHasSignatoryEmails={orgHasSignatoryEmails}
      />
      {isLoading && <Box padding="0 lg lg lg">loading...</Box>}
      {!isLoading && !organization && <Box padding="0 lg lg lg">Organization not found</Box>}
      {!isLoading && organization && children}
    </Card>
  );
};

export default PaymentCard;
